export const SYSTEM_DETAILS_LABEL = 'System Details'
export const DISCOUNT_CODE = 'Discount Code'
